module.exports = __webpack_public_path__ + "static/img/15.be1b428.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/15.png
// module id = BLyk
// module chunks = 0